<template>
  <div class="header">
    <svg
      class="icon back"
      aria-hidden="true"
      @click="back"
    >
      <use xlink:href="#icon-xiaoyuhao" />
    </svg>
    <slot />
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      console.log('返回')
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  padding-top: 30px;
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  .back {
    font-weight: 600;
    font-size: 20px;
    color: #000;
    margin-right: 15px;
  }
}
</style>
